module.exports = __webpack_public_path__ + "img/1722567889260-WhatsApp Image 2024-08-02 at 10.47.46.jpeg.84b5f224.webp";